import { Outlet } from 'react-router-dom';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from './ducks';
import { fetchCenters } from './ducks/centers';
import { logout } from './ducks/auth';
import { setUnauthorizedCallback } from './lib/api';
import { LanguageProvider } from './contexts/LanguageContext';
import Header from './components/common/Header/Header';
import Footer from './components/common/Footer/Footer';
import './App.css';

function App() {
  const dispatch = useDispatch<AppDispatch>();

  const centers = useSelector((state: RootState) => state.centers.items);
  const centersLoading = useSelector((state: RootState) => state.centers.isLoading);

  useEffect(() => {
    // Устанавливаем callback для обработки 401 ошибок
    setUnauthorizedCallback(() => {
      dispatch(logout());
    });

    // Загружаем центры (нужны для фильтрации)
    // Площадки загружаются только на странице Playgrounds для оптимизации
    if (centers.length === 0 && !centersLoading) {
      dispatch(fetchCenters());
    }
    // Площадки НЕ загружаем здесь - только на странице Playgrounds
  }, [dispatch, centers.length, centersLoading]);

  return (
    <LanguageProvider>
      <div className="app">
        <Header />
        <main className="main-content">
          <Outlet />
        </main>
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;

